import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Paper, Button, Grid, TextField } from '@material-ui/core';
import { Dialog, DialogActions } from '@material-ui/core';
import closeLogo from '../../assets/img/closeIcon.svg';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

// REDUX ACTIONS
// import { getAllStudentsOfClass } from '../../store/actions/students.action';
import { updateComment, deleteComment } from '../../store/actions/classfeed.action';
import { getTime } from './PostTimeUtils';

import { getClassInfo, getKneuraId } from '../../utils/authentication-access';
import { withTranslation } from 'react-i18next';
import Avatar from 'react-avatar';

import classes from './Students.module.css';

class CommentComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			chatOpen: false,
			anchorEl: null,
			menuanchorEl: null,
			editComment: false,
			openDeleteDialog: false
		};
	}

	async componentDidMount() {
		this.setState({ commentEditText: this.props.commentinfo.text, userId: getKneuraId() });
	}

	openMenu = (event) => {
		this.setState({ menuanchorEl: event.currentTarget });
	};

	closeMenu = () => {
		this.setState({ menuanchorEl: null });
	};

	editComment = () => {
		this.setState({ editComment: true, menuanchorEl: null, commentEditText: this.props.commentinfo.text });
	};

	closeEditComment = () => {
		this.setState({ editComment: false, commentEditText: this.props.commentinfo.text });
	};

	onEditCommentEnter = (event) => {
		this.setState({ commentEditText: event.target.value });
	};

	keyPress = (event) => {
		if (event.key === 'Enter') {
			this.updateComment();
			event.preventDefault();
		}
	};

	updateComment = async () => {
		const classInfo = getClassInfo();
		if (this.state.commentEditText) {
			if (this.state.commentEditText !== this.props.commentinfo.text) {
				await this.props.updateComment(
					this.props.commentinfo.postId,
					this.props.commentinfo.id,
					this.state.commentEditText,
					classInfo.kneuraId
				);
			}
			this.setState({ editComment: false });
		}
	};

	deleteComment = () => {
		this.setState({ openDeleteDialog: true, menuanchorEl: null });
	};

	closeDeleteDialog = () => {
		this.setState({ openDeleteDialog: false });
	};

	confirmDeleteComment = async () => {
		const classInfo = getClassInfo();
		await this.props.deleteComment(this.props.commentinfo.postId, this.props.commentinfo.id, classInfo.kneuraId);
		this.setState({ openDeleteDialog: false });
	};

	render() {
		const { t } = this.props;
		return (
			<div>
				<Paper elevation={0}>
					<div className={classes.commentHeader}>
						<Avatar
							style={{ justifySelf: 'center' }}
							name={this.props.commentinfo.creator_name}
							src={this.props.commentinfo.creator_profile_url}
							round={true}
							size="25"
						/>

						<div className={classes.commentUserName}>
							{this.props.commentinfo.creator_name}
							<span className={classes.commentTime}>{getTime(this.props.commentinfo.createdAt)}</span>
							{this.props.commentinfo.edited ? <span className={classes.editedText}>edited</span> : ''}
						</div>
						{this.props.commentinfo.creatorId == this.state.userId ? (
							<IconButton size="small" onClick={this.openMenu}>
								<MoreVertIcon fontSize="small" />
							</IconButton>
						) : (
							<div />
						)}
						<div />

						<div
							className={classes.postCommentText}
							style={this.state.editComment ? { display: 'none' } : { display: 'grid' }}
						>
							{this.props.commentinfo.text}
						</div>

						<div
							className={classes.editMessageGrid}
							style={this.state.editComment ? { display: 'grid' } : { display: 'none' }}
						>
							<TextField
								placeholder="Edit Post..."
								defaultValue="Comment"
								size="small"
								multiline
								value={this.state.commentEditText}
								onChange={this.onEditCommentEnter}
								onKeyPress={this.keyPress}
							/>
							<Grid container direction="row" justify="flex-start" alignItems="center">
								<Button style={{ marginRight: 10 }} onClick={this.closeEditComment}>
									Cancel
								</Button>
								<Button
									variant="contained"
									color="primary"
									disableElevation
									onClick={this.updateComment}
								>
									Confirm
								</Button>
							</Grid>
						</div>
					</div>
				</Paper>
				<Menu
					anchorEl={this.state.menuanchorEl}
					keepMounted
					open={Boolean(this.state.menuanchorEl)}
					onClose={this.closeMenu}
				>
					<MenuItem onClick={this.editComment}>Edit</MenuItem>
					<MenuItem onClick={this.deleteComment}>Delete</MenuItem>
				</Menu>
				<Dialog
					fullWidth={true}
					maxWidth={'sm'}
					className="overlay"
					open={this.state.openDeleteDialog}
					onClose={this.closeDeleteDialog}
				>
					<div className="dialog-modal-header bg-delete">
						<div />
						<div className="text-center">
							<img
								className="close-icon hover"
								onClick={this.closeDeleteDialog}
								src={closeLogo}
								alt="Close"
							/>
						</div>
					</div>
					<div className="modal-card">
						<div className="modal-title">{t('Delete Message')}</div>
						<div className="modal-subtitle">
							{t('Are you sure you want to delete this message? This cannot be undone.')}
						</div>

						<DialogActions>
							<Button variant="outlined" onClick={this.closeDeleteDialog}>
								{t('Cancel')}
							</Button>
							<Button
								variant="contained"
								onClick={this.confirmDeleteComment}
								disableElevation
								style={{ backgroundColor: '#BB4512', color: 'white' }}
							>
								{t('Confirm')}
							</Button>
						</DialogActions>
					</div>
				</Dialog>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const classFeedReducer = state.classFeedReducer;
	return {
		posts: classFeedReducer.posts
	};
};

export default connect(mapStateToProps, { updateComment, deleteComment })(
	withRouter(withTranslation()(CommentComponent))
);
